import { createSelector } from 'reselect'
import { getSubscriptionPlansUserSelect } from 'modules/training/modules/training-users/selectors/get-subscription-plans/index.js'

export const getSubscriptionPlanUserSelect = createSelector(
  getSubscriptionPlansUserSelect,
  (subscriptionPlans) => subscriptionPlans?.[0]
)
